"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beCountry = void 0;
var _companyNumber = require("../../companyNumber");
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var beCountry = exports.beCountry = function beCountry(t) {
  return {
    id: 'BE',
    name: t('Belgium'),
    flag: '🇧🇪',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{4}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 1000 or 4000',
    phonePrefix: '32',
    phoneLength: 8,
    pricingVersion: 14,
    timezone: 'Europe/Brussels',
    currency: 'EUR',
    companyNumber: {
      label: _companyNumber.labels.BE,
      checker: _companyNumber.checkers.BE,
      placeholder: '0417497106'
    }
  };
};